const { __ } = wp.i18n;
import FaqsItem from "./FaqsItem";

function FaqsList({ faqs }) {

  if (faqs.length === 0) {
    return (
      <div className="content-faqs__not-found">
        {__('Preguntas frecuentes no encontradas', 'bizum-website')}
      </div>
    );
  }

  return (
    <div className="content-faqs__list">
      {faqs.map((faq, index) =>
        <FaqsItem key={`${faq.slug}-${faq.id}`} faq={faq} isOpen={index === 0 ? true : false} />
      )}
    </div>
  );
}

export default FaqsList;